import {NgxSmartModalComponent} from '../components/ngx-smart-modal.component';

export class ModalInstance {
  public id: string;
  public modal: NgxSmartModalComponent;
}
